var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexagon = function SvgHexagon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M7.478 4.453C9.653 2.818 10.74 2 12 2s2.347.818 4.522 2.453l1.99 1.496c1.997 1.501 2.995 2.252 3.351 3.35.357 1.097-.014 2.278-.756 4.641l-.908 2.893c-.782 2.49-1.173 3.736-2.159 4.451-.986.716-2.31.716-4.958.716h-2.164c-2.648 0-3.972 0-4.958-.716-.986-.715-1.377-1.96-2.159-4.451l-.908-2.893c-.742-2.363-1.113-3.544-.756-4.641.356-1.098 1.354-1.849 3.35-3.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.117 9.827c.914-.566 1.371-.849 1.874-.826.502.024.93.348 1.787.996l.688.521c.886.67 1.329 1.005 1.48 1.496.151.49-.027 1.013-.383 2.06l-.209.61c-.322.946-.483 1.42-.854 1.712-.37.293-.872.342-1.875.442l-.573.057c-1.29.129-1.934.193-2.42-.136-.485-.328-.658-.947-1.005-2.184l-.27-.963c-.31-1.106-.465-1.66-.272-2.153.194-.494.685-.798 1.668-1.407zM2.5 9.5l5.5 2M14.5 16.5 18 21M16 12l5.5-2.5M6.5 21 9 16.5M12 9V2"
  })));
};
export default SvgHexagon;